export default "__VITE_ASSET__DtEWX04b__"